import FolderOutlined from "@mui/icons-material/FolderOutlined";
import PermMediaOutlined from "@mui/icons-material/PermMediaOutlined";
import { type TreeItemProps, TreeItem } from "@mui/x-tree-view";

export const CustomTreeItem = (props: TreeItemProps): React.ReactElement => {
  const isRoot = props.itemId === "0";
  return (
    <TreeItem
      {...props}
      slotProps={{
        ...props.slotProps,
        label: {
          ...props.slotProps?.label,
          style: { display: "flex", alignItems: "center", gap: 8 },
        },
      }}
      label={
        <>
          {isRoot ? <PermMediaOutlined fontSize="small" /> : <FolderOutlined fontSize="small" />}
          {props.label}
        </>
      }
    />
  );
};
